function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.903.362L5 3.264 2.097.362C.977-.758-.757.978.361 2.098 1.33 3.064 2.297 4.033 3.264 5L.36 7.903c-1.118 1.119.617 2.854 1.736 1.736L5 6.736l2.903 2.903c1.119 1.119 2.855-.617 1.736-1.736L6.735 5 9.64 2.097C10.758.977 9.022-.758 7.903.362",
  fill: "#BFB7B6"
});
function SvgCrossGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgCrossGrey;